export default "__VITE_ASSET__CKBEY$Wd__"